import { SessionService } from './SessionService'
import { DapiSuccessPayload, AccountEligibility } from '../types'

export type SuccessPayload = DapiSuccessPayload<{ cards: AccountEligibility[] }>

type QueryAccountEligibility = (params: {
  accountId: string
}) => Promise<AccountEligibility>

export const queryAccountEligibility: QueryAccountEligibility = async ({
  accountId,
}) => {
  const { cif, token } = await SessionService.getData()

  const response = await fetch(
    `/acs/v1/products/bank/eligibility/account/${accountId}`,
    {
      method: 'GET',
      headers: {
        cif: cif.toString(),
        'Content-type': 'application/json',
        Accept: 'application/json',
        authorization: `Bearer ${token}`,
        product: 'debit_card',
      },
    },
  )

  if (!response.ok) throw new Error()

  const {
    cards: [accountEligibility],
  } = (await response.json()) as SuccessPayload

  return accountEligibility
}
